module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__bice_Min.7704cd6c.svg";